import React from "react";
import { Row, Col, Breadcrumb } from "react-bootstrap";

const ProductsBreadcrumb = ({ product, productsPath }) => {
  return (
    <Row>
      <Col xs={12}>
        <Breadcrumb>
          <Breadcrumb.Item href={`${productsPath}/overview`}>
            EDEKA StartHub Übersicht
          </Breadcrumb.Item>
          <Breadcrumb.Item href={`${productsPath}/${product.id}`}>
            {product.brand} {product.name}
          </Breadcrumb.Item>
          <Breadcrumb.Item active>Abverkaufszahlen</Breadcrumb.Item>
        </Breadcrumb>
      </Col>
    </Row>
  );
};

export default ProductsBreadcrumb;
